import React from "react";
import { useTheme } from "@mui/material/styles";

const InfoIcon = ({ size = 16, stroke }) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.system[700];

  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_4634_99557)">
      <path
        d="M8.00001 10.6668V8.00016M8.00001 5.3335H8.00668M14.6667 8.00016C14.6667 11.6821 11.6819 14.6668 8.00001 14.6668C4.31811 14.6668 1.33334 11.6821 1.33334 8.00016C1.33334 4.31826 4.31811 1.3335 8.00001 1.3335C11.6819 1.3335 14.6667 4.31826 14.6667 8.00016Z"
        stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_4634_99557">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>;
};

export default InfoIcon;
